import React from 'react';

const AvailableFlowCard = ({ flow, onSelect, isSelected = false }) => {
  // console.log("flow:", flow);
  return (
    <div 
      className={`available-flow-card ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect(flow)}
    >
      <div className="flow-card-header">
        <div className="flow-card-title">
          <h4>{flow.flow_name}</h4>
        </div>
        <p>{flow.text}</p>
      </div>
    </div>
  );
};

export default AvailableFlowCard;